export default "__VITE_ASSET__Dx1OLK_5__";